import Icon from './Icon'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class DocumentViewPaginator extends PureComponent {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    onNextPageClick: PropTypes.func.isRequired,
    onPrevPageClick: PropTypes.func.isRequired,
    totalPages: PropTypes.number.isRequired
  }

  render() {
    const {
      currentPage,
      totalPages,
      onNextPageClick,
      onPrevPageClick
    } = this.props

    return (
      <div className="box-view-paginator">
        <a className="box-view-btn left" onClick={onPrevPageClick}>
          <Icon name="chevron-left" />
        </a>
        <span className="paginator-pages">
          {currentPage || '-'} / {totalPages || '-'}
        </span>
        <a className="box-view-btn right" onClick={onNextPageClick}>
          <Icon name="chevron-right" />
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/DocumentViewPaginator.js